import {ENDPOINT_REFDATA} from 'common/endpoints';
import {commonJwtHeader} from 'common/utils';

const getItemsByItemCodes = (token, itemCodes) => {
  return fetch(`${ENDPOINT_REFDATA}itemcode/${itemCodes}`, {
    method: 'GET',
    headers: commonJwtHeader(),
  });
};
const getTypesByItemCodes = (token) => {
  return fetch(`${ENDPOINT_REFDATA}codelist/APPLICATION_TYPE`, {
    method: 'GET',
    headers: commonJwtHeader(),
  });
};

const getCountiesByState = (state, token) => {
  return fetch(`${ENDPOINT_REFDATA}countylist?state=${state}`, {
    method: 'GET',
    headers: commonJwtHeader(),
  });
};

const getPrefixes = () => {
  return fetch(`${ENDPOINT_REFDATA}codelist/PREFIX`);
};
const getCodelist = (codelist) => {
  return fetch(`${ENDPOINT_REFDATA}codelist/${codelist}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'cache-control': 'no-cache',
      pragma: 'no-cache',
    },
  });
};

export default {
  getItemsByItemCodes,
  getTypesByItemCodes,
  getPrefixes,
  getCountiesByState,
  getCodelist,
};
